export const SUMMARY_ROW_IDX = 'IDX';
export const SUMMARY_ROW_H5 = 'H5';
export const SUMMARY_ROW_BOX = 'BOX';
export const SUMMARY_ROW_FILE = 'FILE';
export const SUMMARY_ROW_TXT = 'TXT';
export const SUMMARY_ROW_NONE = 'NONE';
export const SUMMARY_ROW_BOLD = 'BOLD';
